import { FC, useEffect } from 'react';

import How from './how/how';
import What from './what/What';
import Why from './why/Why';

const Landing: FC = () => {
    useEffect(() => {
        document.title = 'Vake';
    }, []);
    return (
        <div className="bg-[url('/images/Background.png')] bg-no-repeat bg-center bg-top">
            <Why />
            <How />
            <What />
        </div>
    );
};

export default Landing;
